import * as React from 'react';
import { Props } from 'react';

import { WeatherDialogView } from './Dialogs/WeatherDialogView';
import { WeatherLongDialogView } from './Dialogs/WeatherLongDialogView';
import { CurrenciesDialogView } from './Dialogs/CurrenciesDialogView';
import { CurrenciesLongDialogView } from './Dialogs/CurrenciesLongDialogView';
import { VisaDialogView } from './Dialogs/VisaDialogView';
import { BaggageDialogView } from './Dialogs/BaggageDialogView';
import { AnyQuestionsView } from './Dialogs/AnyQuestionsView';

import './HomeView.scss';
import i18next from 'i18next';

interface HomeViewProps extends Props<HomeView> {
    channelId: string;
}

export class HomeView extends React.Component<HomeViewProps> {
    render() {
        const {channelId} = this.props;
        return (
            <div className='clever-bot-container'>
                <div className='clever-bot-description'>
                    <div>
                        {i18next.t('bot_introduce')}
                    </div>
                    <div className='clever-bot-smile'>
                        {i18next.t('bot_mistakes')} <span className='clever-bot-smile-icon' />
                    </div>
                    <div>
                        {i18next.t('bot_helps')}
                    </div>
                </div>

                <div className='clever-bot-feature'>
                    <div className='clever-bot-feature-title'>
                        {i18next.t('bot_helps_weather')}
                    </div>
                    <div className={`clever-bot-feature-info ${channelId}`}>
                        <WeatherDialogView />
                    </div>
                    <div className='clever-bot-feature-or'>
                        {i18next.t('or')}
                    </div>
                    <div className={`clever-bot-feature-info ${channelId}`}>
                        <WeatherLongDialogView />
                    </div>
                </div>

                <div className='clever-bot-feature'>
                    <div className='clever-bot-feature-title'>
                        {i18next.t('bot_helps_currencies')}
                    </div>
                    <div className={`clever-bot-feature-info ${channelId}`}>
                        <CurrenciesDialogView />
                    </div>
                    <div className='clever-bot-feature-or'>
                        {i18next.t('or')}
                    </div>
                    <div className={`clever-bot-feature-info ${channelId}`}>
                        <CurrenciesLongDialogView />
                    </div>
                </div>

                <div className='clever-bot-feature'>
                    <div className='clever-bot-feature-title'>
                        {i18next.t('bot_helps_visas')}
                    </div>
                    <div className={`clever-bot-feature-info ${channelId}`}>
                        <VisaDialogView />
                    </div>
                </div>

                <div className='clever-bot-feature'>
                    <div className='clever-bot-feature-title'>
                        {i18next.t('bot_helps_baggage')}
                    </div>
                    <div className={`clever-bot-feature-info ${channelId}`}>
                        <BaggageDialogView />
                    </div>
                </div>

                <div className='clever-bot-feature'>
                    <div className='clever-bot-feature-title'>
                        {i18next.t('bot_helps_any')}
                    </div>
                    <div className='clever-bot-feature-info'>
                        <AnyQuestionsView />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CleverBot/Home/HomeView.tsx